import { defineMessages } from 'react-intl';

export default defineMessages({
  legalNoticeTitle: {
    id: 'footer.legal_notice',
  },
  title_CGU: {
    id: 'CGU.title',
  },
  first_title_CGU: {
    id: 'CGU.title.firstCgu',
  },
  first_description_CGU: {
    id: 'CGU.description.firstCgu',
  },
  second_title_cgu: {
    id: 'CGU.title.secondCgu',
  },
  second_description_cgu: {
    id: 'CGU.description.secondCgu',
  },
  third_title_cgu: {
    id: 'CGU.title.thirdCgu',
  },
  third_description_cgu: {
    id: 'CGU.description.thirdCgu',
  },
  forth_title_cgu: {
    id: 'CGU.title.forthCgu',
  },
  forth_description_cgu: {
    id: 'CGU.description.forthCgu',
  },
  five_title_cgu: {
    id: 'CGU.title.fiveCgu',
  },
  five_description_cgu: {
    id: 'CGU.description.fiveCgu',
  },
  six_title_cgu: {
    id: 'CGU.title.sixCGU',
  },
  six_description_cgu: {
    id: 'CGU.description.sixCGU',
  },
  seven_title_cgu: {
    id: 'CGU.title.sevenCGU',
  },
  seven_description_cgu: {
    id: 'CGU.description.sevenCGU',
  },
  eight_title_cgu: {
    id: 'CGU.title.eightCGU',
  },
  eight_description_cgu: {
    id: 'CGU.description.eightCGU',
  },
  nine_title_cgu: {
    id: 'CGU.title.nineCGU',
  },
  nine_description_cgu: {
    id: 'CGU.description.nineCGU',
  },
  ten_title_cgu: {
    id: 'CGU.title.tenCGU',
  },
  ten_description_cgu: {
    id: 'CGU.description.tenCGU',
  },
  eleven_title_cgu: {
    id: 'CGU.title.elevenCGU',
  },
  eleven_description_cgu: {
    id: 'CGU.description.elevenCGU',
  },
  twelve_title_cgu: {
    id: 'CGU.title.twelveCgu',
  },
  twelve_description_cgu: {
    id: 'CGU.description.title.twelveCGU',
  },
  tweenty_title_cgu: {
    id: 'CGU.title.tweentyCGU',
  },
  tweenty_description_cgu: {
    id: 'CGU.description.tweentyCGU',
  },
});
